import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faArrowCircleLeft, faStar } from "@fortawesome/free-solid-svg-icons";

import { environment } from "../../enviornments/enviornment";
import {
    Card, CardImgOverlay, CardImg
} from "reactstrap";
import Img from "react-cool-img";
import "./styles/TrendingToday.scss";

const TrendingToday = (props) => {
    const settings = {
        slidesToShow: 1,
        swipeToSlide: true,
        arrows: false,
        focusOnSelect: true,
        dots: false,
        infinite: false,
        speed: 1000,
        autoplay: false,
        autoplaySpeed: 5000,
    };
    const [data, setData] = useState([]);
    let url = props.dataUrl || "https://api.themoviedb.org/3/trending/all/day";
    useEffect(() => {
        axios.get(`${url}?api_key=${environment.MovieDbApi}`)
            .then(function (response) {
                // handle success
                setData(response.data.results);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }, []);
    let layout = data.map((item, index) => {
        return (
            <Card inverse key={index}>
                <Img width="100%" src={`https://image.tmdb.org/t/p/w500/${item.backdrop_path}`}
                    alt="trending backdrop" className="background-image image-loading card-img" />
                <CardImgOverlay className="p-3">
                    <Img width="100%" className="image-loading poster-image card-img" src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`} alt="trending poster" />
                    <div className="movie">
                        <p className="name font-weight-bold pb-4">{item.title ? item.title : item.name}</p>
                        <p className="rating">
                            {item.vote_average}
                            <FontAwesomeIcon icon={faStar} className={"genere-icon"} size="sm" color="white" />
                        </p>
                    </div>
                </CardImgOverlay>
            </Card>
        );
    });
    return (
        <div className="Trending-carousel-container container-fluid mt-5 p-0">
            <div className="genere-header mb-3 px-2">
                <h5 className={`genere-title font-weight-bold ${props.color}`}>{props.genere ? props.genere : "All"}</h5>
                <div className="genere-icon-container">
                    <FontAwesomeIcon icon={faArrowCircleRight} className={`genere-icon ${props.color}`} size="lg" />
                    <FontAwesomeIcon icon={faArrowCircleLeft} className={`genere-icon ${props.color}`} size="lg" />
                </div>
            </div>
            <Slider {...settings} className="trending-movie-slider pl-2 pr-1">
                {layout}
            </Slider>
        </div>
    );
};

export default TrendingToday;
